/* eslint-disable max-len */
import { get, isUndefined } from 'lodash';
import { i18n } from 'vue-infra';
import { METRIC_NAMES, RESOURCES_CONFIGURATION_INTERVAL as INTERVAL, UNASSIGNED_SKILL_ID } from '@config/Consts';
import { getApiTimeParams, makeArrayOfStrings } from '@core/utils/utils';
import { METRICS_RESOURCE_PARAMS } from '@core/clients/AgentManagerClient';
import { transformRequestQueryParams } from '@core/common/transformers/transform-request-query-params';
import QueueHealthModel from '@core/models/QueueHealthModel';
import BaseClient from '@core/common/BaseClient';

function prepareQueueHealthRequest(settings, httpMethod, params, queryParams) {
  const data = {
    ...settings.filters,
  };
  return {
    method: httpMethod,
    data,
    interval: INTERVAL.GENERAL_RESOURCE,
    body: params,
    config: {
      params: queryParams || {},
    },
  };
}

function transformQueueHealthRequest(settings) {
  const queryParams = {};
  const params = {
    metricsToRetrieveByTime: [],
    metricsToRetrieveCurrentValue: [
      METRICS_RESOURCE_PARAMS.REQUEST_METRICS_TO_RETRIEVE_CURRENT_VALUE.OVERDUE_IN_QUEUE,
      METRICS_RESOURCE_PARAMS.REQUEST_METRICS_TO_RETRIEVE_CURRENT_VALUE.UNASSIGNED,
      METRICS_RESOURCE_PARAMS.REQUEST_METRICS_TO_RETRIEVE_CURRENT_VALUE.HUMAN_AGENT_LOAD,
      METRICS_RESOURCE_PARAMS.REQUEST_METRICS_TO_RETRIEVE_CURRENT_VALUE.ONLINE_AGENTS,
      METRICS_RESOURCE_PARAMS.REQUEST_METRICS_TO_RETRIEVE_CURRENT_VALUE.AWAY_AGENTS,
      METRICS_RESOURCE_PARAMS.REQUEST_METRICS_TO_RETRIEVE_CURRENT_VALUE.WAIT_TIME_90,
    ],
    responseSections: [
      METRICS_RESOURCE_PARAMS.RESPONSE_SECTIONS.GROUP_BY,
      METRICS_RESOURCE_PARAMS.RESPONSE_SECTIONS.ALL,
    ],
    groupBy: METRICS_RESOURCE_PARAMS.REQUEST_GROUP_BY.SKILL,
  };

  params.filters = {};
  if (settings.filter.groupIds && settings.filter.groupIds.length > 0) {
    params.filters.agentGroupIds = makeArrayOfStrings(settings.filter.groupIds);
  }
  if (settings.timeframe) {
    const apiTimeParams = getApiTimeParams(settings.timeframe);
    params.filters.time = { from: apiTimeParams.lastUpdateFrom, to: apiTimeParams.to };
  }
  if (settings.filter.skills && settings.filter.skills.length > 0) {
    params.filters.skillIds = makeArrayOfStrings(settings.filter.skills);
  }
  return prepareQueueHealthRequest(
    settings,
    BaseClient.HTTP_METHODS.POST,
    params,
    transformRequestQueryParams(queryParams, settings),
  );
}

function transformQueueHealthResponse(response) {
  const data = [];
  const skillMetricRecords = get(response, 'currentQueueHealthResponse.data.groupBy.groups');
  if (!isUndefined(skillMetricRecords)) {
    skillMetricRecords.forEach((record) => {
      const recordMetrics = get(record, 'metrics');
      if (!isUndefined(recordMetrics)) {
        const skillRecord = new QueueHealthModel({
          [METRIC_NAMES.CONVERSATION_IN_QUEUE_WAIT_TIME]:
            get(recordMetrics,
              'queueWaitTime90thPercentile', null),
          [METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS]:
            get(recordMetrics, 'unassignedConversations', 0),
          id: record.key !== UNASSIGNED_SKILL_ID.toString() ? (record.keyDescription || record.key) : i18n.t('amd:queue_health_unassigned_skill_name'),
        });
        data.push(skillRecord);
      }
    });
  } else {
    // This is done in order to mark the data as Obsolete since it's not of type QueueHealthModel
    data.push(skillMetricRecords);
  }
  const globalValuesRecord = get(response, 'currentQueueHealthResponse.data.all');
  const queueHealthTotalRecord = get(globalValuesRecord, 'unassignedConversations');
  const queueHealthOverdueRecord = get(globalValuesRecord, 'overdueConversationsInQueue');
  let skillsTotalCount = get(response, 'currentQueueHealthResponse.data.metadata.count');
  if (isUndefined(skillsTotalCount)) {
    skillsTotalCount = Array.isArray(skillMetricRecords) ? skillMetricRecords.length : 0;
  }
  return {
    data,
    total: queueHealthTotalRecord,
    overdue: queueHealthOverdueRecord,
    skillsTotalCount
  };
}

export default {
  transformQueueHealthRequest,
  transformQueueHealthResponse,
};
